import { render, staticRenderFns } from "./EditTeamMembers.vue?vue&type=template&id=585f71b8&scoped=true"
import script from "./EditTeamMembers.vue?vue&type=script&lang=ts"
export * from "./EditTeamMembers.vue?vue&type=script&lang=ts"
import style0 from "./EditTeamMembers.vue?vue&type=style&index=0&id=585f71b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f71b8",
  null
  
)

export default component.exports